




























import Vue from 'vue';

import AppFooter from '@/components/Footer.vue';
import AppHeader from '@/components/Header.vue';

export default Vue.extend({
  components: {
    AppHeader,
    AppFooter,
  },
  computed: {
    hasFooter(): boolean {
      return this.$route.meta.hasFooter === false ? false : true;
    },
  },
});
